import type { FC, ReactNode } from 'react'
import type { ProductoResumen } from '@/types'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import { buttonVariants } from '@/components/ui/button'
import Container from '@/components/generals/container'
import SectionHeading from '@/components/generals/section-heading'
import ProductCard from '@/components/catalog/product-card'

interface FeaturedProductsProps {
    productos: Array<ProductoResumen>
}

const FeaturedProducts: FC<FeaturedProductsProps> = ({ productos }): ReactNode => {
    return (
        <section id='destacados' aria-labelledby='destacados-titulo' className='surface-grain relative bg-graphite py-24 md:py-32'>
            <Container>
                <div className='flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between'>
                    <SectionHeading
                        id='destacados-titulo'
                        eyebrow='Piezas destacadas'
                        title='Piezas que dejan huella.'
                        description='Una selección de referencias del catálogo. Todas pueden adaptarse en materiales, medidas, acabados e inscripciones.'
                    />

                    <Link href='/catalogo' className={buttonVariants({ variant: 'outline' })}>
                        Ver catálogo completo
                        <ArrowRight aria-hidden='true' />
                    </Link>
                </div>

                {productos.length > 0 ? (
                    <div className='mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3'>
                        {productos.map(producto => (
                            <div key={producto.id} className='reveal'>
                                <ProductCard producto={producto} tone='black' />
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className='mt-14 rounded-sm border border-dashed border-ivory/15 px-6 py-12 text-center text-muted-foreground'>
                        Las piezas destacadas aparecerán aquí cuando se marquen en el catálogo.
                    </p>
                )}

                <p className='mt-10 text-xs leading-relaxed text-ivory/50'>
                    Las referencias son orientativas. Cada pieza se cotiza según cantidad, materiales, dimensiones y personalización.
                </p>
            </Container>
        </section>
    )
}

export default FeaturedProducts
